var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "fill-height ma-n8",
    attrs: {
      "align": "center"
    }
  }, [_vm._l(_vm.peers, function (peer, index) {
    return [_c('v-col', _vm._b({
      key: index,
      staticClass: "pa-8"
    }, 'v-col', _vm.colProps, false), [_c('room-video', _vm._b({}, 'room-video', peer, false))], 1)];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }